import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Markdown from 'markdown-to-jsx';

import Card from "../../../../Components/UI/Card/Card";

import { configActions } from '../../../../lib/configStore';

import styles from "./InfoTab.module.css";

const errorText = `Error: No text available. Please define the infoText in the admin panel.`;

const InfoTab = (props) => {
  const configData = useSelector(state => state.config.data);

  useEffect(() => { props.onValidChange(true); }, []);   

  return (
    <Card className={styles.infoCard}>
      <div style={{ lineHeight: "130%" }}>
        <Markdown>{ configData.infoText || errorText }</Markdown>
      </div>
      <div style={{ marginTop: "1rem", paddingTop: "1rem", borderTop: "1px solid #e8d5cf" }}>
        <a href="/kidsdoc_faq" target="_blank" rel="noopener noreferrer"
           style={{
             display: "inline-block",
             padding: "6px 14px",
             background: "#CE5328",
             color: "#fff",
             borderRadius: "3px",
             textDecoration: "none",
             fontSize: "0.9rem",
             fontWeight: 500,
           }}
           onMouseOver={e => e.currentTarget.style.background = "#F0612F"}
           onMouseOut={e  => e.currentTarget.style.background = "#CE5328"}>
          Häufig gestellte Fragen (FAQ)
        </a>
      </div>
    </Card>
  );
};

export default InfoTab;
